<div
  class="gsp-root"
  *ngIf="open()"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'navbar.search_aria' | transloco"
  (click)="close()"
>
  <div class="gsp-panel" (click)="$event.stopPropagation()" (keydown)="onKeydown($event)">
    <header class="gsp-head">
      <span class="material-icons-outlined gsp-icon">search</span>
      <input
        #queryInput
        type="search"
        class="gsp-input"
        [placeholder]="'navbar.search_placeholder' | transloco"
        [value]="query()"
        (input)="onQueryInput($any($event.target).value)"
        autocomplete="off"
        autocapitalize="off"
        spellcheck="false"
        enterkeyhint="search"
      />
      <kbd class="gsp-kbd" *ngIf="!query()">{{ isMac() ? '⌘K' : 'Ctrl+K' }}</kbd>
      <button type="button" class="gsp-close" (click)="close()" [attr.aria-label]="'common.close' | transloco">
        <span class="material-icons-outlined">close</span>
      </button>
    </header>

    <div class="gsp-body" role="listbox">
      <p class="gsp-status" *ngIf="loading()">{{ 'navbar.search_loading' | transloco }}</p>

      <ng-container *ngIf="displayGroups() as groups">
        <section class="gsp-group" *ngFor="let g of groups">
          <h3 class="gsp-group-title">{{ g.label }}</h3>
          <button
            type="button"
            class="gsp-hit"
            *ngFor="let hit of g.items; trackBy: trackHit"
            role="option"
            [class.is-active]="flatIndexOf(hit) === activeIndex()"
            [attr.aria-selected]="flatIndexOf(hit) === activeIndex()"
            (click)="select(hit)"
            (mouseenter)="activeIndex.set(flatIndexOf(hit))"
          >
            <span class="material-icons-outlined gsp-hit-icon">{{ hit.icon }}</span>
            <span class="gsp-hit-text">
              <strong>{{ hit.title }}</strong>
              <small *ngIf="hit.subtitle">{{ hit.subtitle }}</small>
            </span>
            <span class="gsp-hit-kind">{{ kindLabel(hit.kind) }}</span>
          </button>
        </section>

        <div
          class="gsp-empty"
          *ngIf="!loading() && !groups.length && query().trim().length >= 2"
        >
          <span class="material-icons-outlined">search_off</span>
          <p>{{ 'navbar.search_empty' | transloco }}</p>
        </div>

        <div class="gsp-hint" *ngIf="!query().trim() && !groups.length">
          <p>{{ 'navbar.search_hint' | transloco }}</p>
        </div>
      </ng-container>
    </div>

    <footer class="gsp-foot">
      <span><kbd>↑</kbd><kbd>↓</kbd> {{ 'navbar.search_nav' | transloco }}</span>
      <span><kbd>↵</kbd> {{ 'navbar.search_open' | transloco }}</span>
      <span><kbd>esc</kbd> {{ 'navbar.search_dismiss' | transloco }}</span>
    </footer>
  </div>
</div>
